import { FC } from 'react';
import { format } from 'd3-format';
import { ScaleLinear } from 'd3-scale';
import React from 'react';
import { GraphLayoutLeftAxis, GraphLayoutRightAxis } from '../ChartPanel';

interface ValueAxisProps {
  valueScale: ScaleLinear<number, number>;
  color?: string;
  percentage?: boolean;
  formatter?: (unformatted: number) => string;
  height?: number;
  ticks?: number[];
}

const VerticalLeftValueAxis: FC<ValueAxisProps> = props => {
  const { percentage, valueScale, color, height } = props;
  const formatter = percentage
    ? (d: number) => `${d}%`
    : props.formatter
    ? props.formatter
    : format(',');
  const ticks = props.ticks ? props.ticks : valueScale.ticks();
  const formattedTicks = ticks.map(formatter);

  let width =
    formattedTicks.reduce((a, b) => (a = a < b.toString().length ? b.toString().length : a), 0) * 6;
  if (percentage) {
    width += 8;
  }
  const axis = ticks.map((tick, i) => {
    const value = valueScale(tick);
    const displayValue = formattedTicks[i];
    return (
      <text x={width} fill={color || '#848484'} y={value} fontSize="10px" key={i}>
        {displayValue}
      </text>
    );
  });
  return (
    <GraphLayoutLeftAxis
      viewBox={`0 0 ${width} ${height ? height : valueScale.range[0]}`}
      width={width}
      height={height}
    >
      {axis}
    </GraphLayoutLeftAxis>
  );
};

const VerticalRightValueAxis: FC<ValueAxisProps> = props => {
  const { percentage, valueScale, color, height } = props;
  const formatter = percentage
    ? (d: number) => `${d}%`
    : props.formatter
    ? props.formatter
    : format(',');
  const ticks = props.ticks ? props.ticks : valueScale.ticks();
  const formattedTicks = ticks.map(formatter);

  let width =
    formattedTicks.reduce((a, b) => (a = a < b.toString().length ? b.toString().length : a), 0) * 6;
  if (percentage) {
    width += 8;
  }
  const axis = ticks.map((tick, i) => {
    const value = valueScale(tick);
    const displayValue = formattedTicks[i];
    return (
      <text x={0} fill={color || '#848484'} y={value} fontSize="10px" key={i}>
        {displayValue}
      </text>
    );
  });
  return (
    <GraphLayoutRightAxis
      viewBox={`0 0 ${width} ${height ? height : valueScale.range[0]}`}
      width={width}
      height={height}
    >
      {axis}
    </GraphLayoutRightAxis>
  );
};

export { VerticalLeftValueAxis, VerticalRightValueAxis };
